/**
 * This barrel file provides the exports for the shared resources (services, components).
 */
export * from './topnav/index';
export * from './footer/index';
export  * from './shared.module';
